import { InputProps, SelectInput } from "react-admin"

import { PaymentStatusChoices } from "../../billing_constants"

export const BillPaymentStatusSelectInput: React.FC<InputProps> = (props) => (
  <SelectInput {...props} choices={PaymentStatusChoices} />
)
